const PPT_EXTENSIONS = ['ppt', 'pptx']
const PPT_MIME_KEYWORDS = ['powerpoint', 'presentationml', 'ms-powerpoint']

const trimValue = (value) => String(value || '').trim()

export const getFileExtension = (value) => {
  const raw = trimValue(value)
  if (!raw) return ''

  const path = raw.split('?')[0].split('#')[0]
  const fileName = path.split('/').pop() || path
  const index = fileName.lastIndexOf('.')

  return index >= 0 ? fileName.slice(index + 1).toLowerCase() : raw.toLowerCase()
}

export const isPptFile = (source = {}) => {
  if (typeof source === 'string') {
    return PPT_EXTENSIONS.includes(getFileExtension(source))
  }

  if (!source || typeof source !== 'object') {
    return false
  }

  const explicitType = trimValue(
    source.file_type ||
    source.extension ||
    source.format ||
    source.type
  ).toLowerCase()

  if (PPT_EXTENSIONS.includes(explicitType)) {
    return true
  }

  const mimeType = trimValue(source.mime_type || source.mimeType).toLowerCase()
  if (PPT_MIME_KEYWORDS.some(keyword => mimeType.includes(keyword))) {
    return true
  }

  return [
    source.name,
    source.file_name,
    source.title,
    source.url,
    source.file_url,
    source.preview_url,
    source.previewUrl,
    source.resource_url,
    source.resourceUrl
  ].some(value => PPT_EXTENSIONS.includes(getFileExtension(value)))
}

export const buildPptPreviewQuery = (payload = {}) => {
  const source = payload.file && typeof payload.file === 'object' ? payload.file : {}
  const query = {}

  const fileId = payload.fileId || payload.file_id || source.file_id
  const shareSpaceId = payload.shareSpaceId || payload.share_space_id || source.share_space_id
  const textbookId = payload.textbookId || payload.textbook_id || source.textbook_id
  const url = payload.url || payload.fileUrl || payload.file_url || source.file_url || source.url || source.preview_url || source.previewUrl
  const title = payload.title || source.title || source.name || source.file_name
  const fileType = payload.fileType || payload.file_type || source.file_type || source.extension

  if (fileId) query.id = fileId
  if (shareSpaceId) query.share_space_id = shareSpaceId
  if (textbookId) query.textbook_id = textbookId
  if (url) query.url = url
  if (title) query.title = title
  if (fileType) query.file_type = fileType

  return query
}

export const resolvePptPreviewHref = (router, payload = {}) => {
  const route = {
    name: 'ppt-preview',
    query: buildPptPreviewQuery(payload)
  }

  return router.resolve(route).href
}

export const openPptPreviewInNewPage = (router, payload = {}) => {
  const href = resolvePptPreviewHref(router, payload)
  window.open(href, '_blank', 'noopener')
}
